import {ReactNode} from 'react';
import React from 'react';

import BitmovinLogo from '../media/hexagonIconImage/icons/about_us.svg';
import ExceptionalViewerExperienceSvg from '../media/hexagonIconImage/icons/exceptional_viewer_experience.svg';
import OperationalOptimizationSvg from '../media/hexagonIconImage/icons/operational_optimization.svg';

export interface IAnalyticsNoteworthyFeature {
  readonly name: string;
  readonly description: ReactNode;
  readonly iconPath: string;
}

const AnalyticsNoteworthyFeatureData: ReadonlyArray<IAnalyticsNoteworthyFeature> = [
  {
    name: 'High quality',
    description: (
      <div>
        <p>
          Flawed video streams with long start-up times and other quality problems cost you viewers and money - our cost
          of errors calculator shows you how much. Bitmovin’s Analytics captures data in real-time so you can spot and
          resolve streaming issues fast.
        </p>
        <p>
          Often the errors are ambiguous and the root causes are not easy to identify. Session-level data provides
          context around errors and lets you find and fix them faster; ultimately improving the viewer experience while
          efficiently using your resources.
        </p>
        <p>
          Metrics such as the one for video codec support help you to make better streaming decisions that drive higher
          streaming quality. How? Understanding the codec composition among your platform end-users you can deliver
          higher quality video to viewers with less available bandwidth or deliver higher quality video while spending
          less on delivery costs (CDN).
        </p>
      </div>
    ),
    iconPath: ExceptionalViewerExperienceSvg
  },
  {
    name: 'Ease of use',
    description: (
      <div>
        <p>
          On average, it takes around 140 hours of development resources to complete video analytics integration.
          Integrating Bitmovin Analytics needs 10x fewer resources. Our Bitmovin Analytics integration is done rapidly
          and with low complexity.
        </p>
        <p>
          Dedicated collectors enable integration in days instead of months. You receive valuable production data faster
          and reduce your development resources significantly.
        </p>
        <p>
          We further offer data portability built to fit into any data architecture through API, dashboard integrations,
          and full data export. This ensures that data can be easily merged in central data repositories.
        </p>
      </div>
    ),
    iconPath: OperationalOptimizationSvg
  },
  {
    name: 'Always innovative',
    description: (
      <div>
        <p>Identify errors faster without having to replicate them with the Network explorer.</p>
        <p>Gain insights into video performance across the globe with Industry Insights our benchmarking tool.</p>
      </div>
    ),
    iconPath: BitmovinLogo
  }
];

export default AnalyticsNoteworthyFeatureData;
